import Vue from "vue";
import Router from "vue-router";
import store from "./store";
Vue.use(Router);

const newRouter = new Router({
    // mode: 'history',
    routes: [{
        path: "*",
        redirect: "/dev_login"
    },
    {
        path: "/dev_login",
        name: "dev_login",
        component: resolve => require(["./components/dev_login.vue"], resolve)
    },
    {
        path: "/ef-seller",
        name: "EFSeller",
        component: resolve => require(["./components/tiktok/test.vue"], resolve)
    },
    ]
});
const whiteList = [
    "/login",
    "/dev_login",
];
const permissionsPath = JSON.parse(localStorage.getItem("permissionsPath"));
const indexPath = localStorage.getItem("indexPath");
newRouter.beforeEach((to, from, next) => {
    if (!!store.getters.token) {
        if (to.path === "/login") {
            // console.log(to)
            //微服务携带token以及路径跳转
            if (to.query.currentPath) {
                localStorage.setItem("token", to.query.token);
                sessionStorage.setItem("token", to.query.token);
                store.commit("SET_TOKEN", to.query.token);
                store.commit('set_currentPath', to.query.currentPath)
                store.dispatch("GetInfo").then(res => {
                    next({
                        path: to.query.currentPath
                    });
                });
            } else {
                // to.path === indexPath ?
                //     next() :
                //     next({
                //         path: indexPath
                //     });
                if (to.path === indexPath) {
                    next()
                    window.location.href = odErpHost + '/#' + indexPath;
                } else {
                    next()
                }
            }
        } else if (permissionsPath && permissionsPath.indexOf(to.path) == -1) {
            // console.log(indexPath)
            // console.log(to.path)
            if (to.path === indexPath) {
                console.log('没有页面权限')
                next()
                window.location.href = odErpHost + '/#' + indexPath
            } else {
                next()
            }

        } else {
            next();
        }
    } else {
        if (whiteList.indexOf(to.path) !== -1) {
            next();
        } else {
            next("/login");
        }
    }
});

export default newRouter;
